import React from 'react'
import CallbackForm from '../molecules/CareerComponents/CallbackFrom/CallbackForm'
import Heading from '../atoms/Heading/Heading'
import Footer from '../organisms/Footer/Footer'

const ContactUSPage = () => {
    return (
        <div className='bg-darkGreyPrimary pt-32 md:pt-52 h-screen'>
            <Heading title='CONTACT US' subTitle="Let's discuss your opportunities." />
            <CallbackForm />
            <div className='bg-darkGreyPrimary'>
                <Footer />
            </div>
        </div>
    )
}

export default ContactUSPage
